import React from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  useParams,
  Outlet,
} from "react-router-dom";
import "@/App.css";
import { I18nProvider } from "@/i18n";
import ScrollToTop from "@/components/ScrollToTop";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import { PrivacyPage, CookiesPage, TermsPage } from "@/pages/LegalPages";
import ThankYou from "@/pages/ThankYou";

const SUPPORTED = ["mx", "en"];

const LanguageShell = () => {
  const { lang } = useParams();
  if (!SUPPORTED.includes(lang)) {
    return <Navigate to="/mx" replace />;
  }
  return (
    <I18nProvider lang={lang}>
      <Layout>
        <Outlet />
      </Layout>
    </I18nProvider>
  );
};

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Navigate to="/mx" replace />} />
        <Route path="/thank_you" element={<ThankYou />} />
        <Route path=":lang" element={<LanguageShell />}>
          <Route index element={<Home />} />
          <Route path="privacy" element={<PrivacyPage />} />
          <Route path="cookies" element={<CookiesPage />} />
          <Route path="terms" element={<TermsPage />} />
        </Route>
        <Route path="*" element={<Navigate to="/mx" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
